export const SAVE_SELECTED = 'SAVE_SELECTED';
export const ADD_REVISION_TERM_ID = 'ADD_REVISION_TERM_ID';
export const ADD_SELECTED_GRID_ROW = 'ADD_SELECTED_GRID_ROW';